export default __webpack_public_path__ + "static/media/login.0e2d619f.svg";